import { render } from "./ModalEditQuestions.vue?vue&type=template&id=143b8c12&scoped=true"
import script from "./ModalEditQuestions.vue?vue&type=script&lang=js"
export * from "./ModalEditQuestions.vue?vue&type=script&lang=js"

import "./ModalEditQuestions.vue?vue&type=style&index=0&id=143b8c12&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143b8c12"]])

export default __exports__